import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../lib/api';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Input } from '../components/ui/input';
import { Star, CheckCircle2, ChefHat } from 'lucide-react';

export default function Feedback() {
  const { tenantId } = useParams();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [phone, setPhone] = useState('');
  const [done, setDone] = useState(false);

  const submit = async () => {
    await api.post('/feedback', { rating, comment, customer_phone: phone }, { params: { tenant_id: tenantId } });
    setDone(true);
  };

  if (done) return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 text-center bg-background">
      <CheckCircle2 className="h-16 w-16 text-success mb-4" />
      <h1 className="font-display text-2xl font-bold">Thank You!</h1>
      <p className="text-muted-foreground">Your feedback helps us serve you better.</p>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-md p-6 space-y-4">
        <div className="flex items-center gap-2"><div className="h-10 w-10 rounded-xl bg-primary flex items-center justify-center"><ChefHat className="h-5 w-5 text-primary-foreground" /></div><div className="font-display font-bold text-xl">How was your experience?</div></div>
        <div className="flex justify-center gap-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} data-testid={`rating-${n}`} onClick={() => setRating(n)}><Star className={`h-10 w-10 ${n <= rating ? 'text-amber-500 fill-amber-500' : 'text-muted'}`} /></button>
          ))}
        </div>
        <Textarea placeholder="Tell us more (optional)…" value={comment} onChange={(e) => setComment(e.target.value)} />
        <Input placeholder="Phone (optional)" value={phone} onChange={(e) => setPhone(e.target.value)} />
        <Button data-testid="feedback-submit" className="w-full" disabled={!rating} onClick={submit}>Submit Feedback</Button>
      </Card>
    </div>
  );
}
